module.exports = __webpack_public_path__ + "img/奖章3级@3x.72d8b054.png";